import React from 'react'
import CallToAction from '../../shared/CallToActionButton'
import ButtonLink from '../../shared/ButtonLink'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import TrustpilotItem from 'src/components/shared/TrusPilotItem'
import { ConsentBanner } from 'src/components/shared/ConsentBanner'
import { Logo } from '../ActualHeader'
import { useFeatureFlags } from 'src/common/ab-testing/context'
import { featureToggles } from 'src/common/constants/featureToggles'
import { experimentSectionByVariation } from 'src/common/analytics/consts'
import { useChatbot } from 'src/common/ChatbotProvider'
import { ChatbotButtonDesktop } from 'src/components/shared/Chatbot/components/ChatbotButtonDesktop'

export const LoadTrustpilotItem = () => (
  <div className="flex w-full items-center justify-center bg-green-40 py-1 text-center text-14 font-medium lg:text-16">
    <TrustpilotItem
      starClassName="w-5.5 h-5.5"
      trustpilotRatingClassName="text-base whitespace-nowrap text-ellipsis overflow-hidden"
      starsGroupClassName="w-20 h-5 mx-2"
      className="my-0 overflow-hidden text-ellipsis"
      shortText
      detailsText
      disableRedirect
      starsGroupImgClassName="pt-1"
      imagePriority={false}
    />
  </div>
)

const StickyButtons = ({
  handleButtonClick,
  phoneNumberText = '',
  show = false,
}) => {
  const { getExperimentVariation } = useFeatureFlags()
  const { isChatbotEnabled } = useChatbot()

  const chatbotExperiment = getExperimentVariation(
    experimentSectionByVariation[featureToggles.FDR_CHATBOT]
  )

  return (
    <>
      {/* Sticky Header Desktop */}
      <div
        aria-hidden={!show}
        className={classNames(
          'fixed top-0 left-0 z-101 hidden w-full flex-col items-center justify-center bg-white drop-shadow-md transition-[transform,opacity,visibility] duration-300 lg:flex',
          show
            ? 'translate-y-0 opacity-100'
            : 'pointer-events-none invisible -translate-y-full opacity-0'
        )}
      >
        <div
          className="flex items-center justify-center"
          data-testid="sticky-header-container"
        >
          <Logo />
          <div className="flex items-center justify-center">
            <p
              className="mt-[-10px] mr-5 ml-5.5  shrink-0 text-14 text-gray-255"
              data-testid="sticky-header-text"
            >
              Get credit card debt relief from America&apos;s top debt relief
              company.
            </p>
            <div
              className=" flex shrink-0 flex-col items-center"
              data-testid="sticky-header-actions"
            >
              <div
                className="mt-5 flex"
                data-testid="sticky-header-actions-row"
              >
                <ButtonLink
                  className="mr-5 rounded-lg border-2 border-blue-base px-5 py-2 text-16 font-bold text-blue-base"
                  href={`tel:${phoneNumberText}`}
                  onClick={(href) =>
                    handleButtonClick?.(
                      href,
                      `Call ${phoneNumberText}`,
                      'Floating Menu',
                      false
                    )
                  }
                >
                  Call {phoneNumberText}
                </ButtonLink>
                <CallToAction
                  text="See if you qualify"
                  bgColor="bg-red-850"
                  className="m-0! w-auto! max-w-max rounded-lg px-5 py-2.25"
                  fontClassName="font-bold text-white"
                  nav_link_section="Floating Menu"
                  withArrow={false}
                />
              </div>
              <TrustpilotItem
                starClassName="w-5.5 h-5.5"
                trustScoreClassName="text-base"
                trustpilotClassName="text-base"
                trustpilotRatingClassName="text-base"
                starsGroupClassName="w-20 h-5 mx-2.5"
                className="my-2"
                shortText
                disableRedirect
                detailsText
                starsGroupImgClassName="pt-1"
                imagePriority={false}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Sticky Footer Mobile */}
      <div className="fixed inset-x-0 bottom-0 z-100 lg:hidden">
        {show &&
          isChatbotEnabled &&
          ['Variation_B'].includes(chatbotExperiment) && (
            <div className="mr-2 mb-2 flex justify-end">
              <ChatbotButtonDesktop />
            </div>
          )}

        <ConsentBanner />
      </div>
    </>
  )
}

StickyButtons.propTypes = {
  handleButtonClick: PropTypes.func,
  phoneNumberText: PropTypes.string,
  show: PropTypes.bool,
}
export default StickyButtons
